var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-row',[(_vm.alert.message)?_c('el-alert',{attrs:{"title":_vm.alert.message,"type":_vm.alert.type,"effect":"dark"}}):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }